import React from "react";
import Image from "next/image";

const StatsMilesDesktop = () => {
  //   // State to track hover on each card

  return (
    <>
      {/* Desktop version */}

      <div className="relative 2xl:bg-bottom bg-center bg-repeat bg-[length:100% 100%] md:block hidden">
        <Image
          priority
          src="/about-us/photos-grid-team-big.png"
          alt="Accoun"
          className=""
          width={1650}
          height={1035}
        />
      </div>
    </>
  );
};

export default StatsMilesDesktop;
